var exports = {
  "J": "assignYourselfButton__R0BvLy",
};

module.exports = exports;
